import { AuthenticationResult } from '@azure/msal-browser';
import Axios from 'axios';
import { config } from './config';

export const ppClient = Axios.create({
  baseURL: config.pp.apiUrl,
});

export function authenticatePpClient(authentication: AuthenticationResult | null) {
  if (authentication) {
    ppClient.interceptors.request.use(config => {
      config.headers.Authorization = `Bearer ${authentication.idToken}`;
      return config;
    });
  } else {
    ppClient.interceptors.request.clear();
  }
}

export function setAcceptLanguage(lang: string) {
  ppClient.defaults.headers['accept-language'] = lang;
}
